import {Component, OnInit} from '@angular/core';
import {AdminService} from '../admin.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {ApiService} from '../../services/api.service';
import {NotificationsService} from 'angular2-notifications';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-config',
  templateUrl: './config.component.html',
  styleUrls: ['./config.component.css']
})
export class ConfigComponent implements OnInit {

  configs: any;
  configForm: FormGroup;
  showmsg: string;

  constructor(private adminService: AdminService,
              private apiService: ApiService,
              private notifications: NotificationsService,
              private fb: FormBuilder,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.getUserConfiguration();
    this.configForm = this.fb.group({
      'parserNrInstancePerProc': ['', Validators.compose([Validators.required])],
      'parserSectionByteSizeHint': ['', Validators.compose([Validators.required])]
    });
  }

  getUserConfiguration() {
    this.showmsg = null;
    this.adminService.getConfigurations()
      .subscribe((res) => {
        this.showmsg = this.translate.instant('admin.config.refreshed') + ' - ' + new Date();
        this.configs = res.json();
      }, (err) => {
          this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(err, this.translate.instant('admin.config.faliedConf')));
      });
  }

  updateUserConfiguration(config) {
    const data = {
      parserNrInstancePerProc: config.parserNrInstancePerProc,
      parserSectionByteSizeHint: config.parserSectionByteSizeHint
    };
    this.showmsg = null;
    this.adminService.updateConfiguration(data)
      .subscribe((res) => {
        this.showmsg = this.translate.instant('admin.config.refreshed') + ' - ' + new Date();
        this.configs = res.json();
      }, (error) => {
            this.notifications.error(this.translate.instant('common.error'), this.apiService.getMessageFromError(error, this.translate.instant('admin.config.faliedConf')));
      });
  }

  refreshConfig() {
    this.getUserConfiguration();
  }


}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/admin/config/config.component.ts